
<!-- List of Report Cards -->
<div *ngIf="showReportList" class="container pd-sm-t20">
    <h2 class="heading">Reports</h2>
<ng-container *ngFor="let report of subTaskMenu">
    <div class="cards__item d-flex">
        <p class="cards__icon--bg"></p>
        <div class="cards__item--info pd-t20 pd-b20">
            <div class="cards__item--infobox br-5 d-flex mg-r20 light-bg">
                <div class="locked-overlay"></div>
                <div class="card__item--img">
                    <img *ngIf="report.image" src={{report.image}} alt="Report">
                    <img *ngIf="!report.image" src="../../../../../assets/images/One-on-one coaching icon-01.png" alt="Report">
                </div>
                <div class="card__item--cont">
                    <p class="card__item--title dark-color text-capitalize">
                        {{report.title}}</p>
                    <ul class="card__item--desc dark-color">
                        <li class="d-inline">
                            {{report.description}}</li>
                        
                        </ul>
                        <div class="card__item--bottom">
                            <div class="d-inline completed" *ngIf="report.status == 'Complete'">
                                Completed</div>
                            <div class="d-inline upcoming" *ngIf="report.status == 'Upcoming'">
                                Upcoming</div>
                            <div class="d-inline" *ngIf="report.status == 'Text'">
                                {{report.text}}</div>
                            <div class="d-inline" *ngIf="report.status == 'Date'">
                                {{report.date |
                                    date:dateFormat}}</div></div>
                </div>
                <div class="cards__item--button">
                    <a class="card__item--link pd-t10 pd-b10 link-no-underline primary-color text-center cursor-pointer" (click)="openReport(report.url)" *ngIf="report.cta">
                        {{report.cta}} </a>
                </div>
            </div>
        </div>
    </div>

</ng-container>
</div>